import { gql } from 'apollo-angular';
import { Role } from '../../entities/role/role';

export const GET_ROLES_QUERY = gql`
query roles{
  getRoles{
    name
    label
  }
}
`;

export interface GetRolesResponse {
  getRoles: Role[];
  loading: boolean;
}
